module.exports = __webpack_public_path__ + "img/45600.b3d1b56e.jpg";